import { DataBean } from "../DataBean";

export class UBLTaxWithHoldingTax extends DataBean{

    public async getUBLTaxWithHoldingTaxCatalog(idUBLInvoice:number,issueDate:any):Promise<any>{
        return this.getCustomService("QuickDataERPCore","java.util.List_getUBLTaxWithHoldingTaxCatalog_Number_java.util.Date",[idUBLInvoice,issueDate]);
    }

    public async getUBLTaxWithHoldingTaxTaxCatalog(idUBLInvoice:number,issueDate:any,state: number):Promise<any>{
        return this.getCustomService("QuickDataERPCore","java.util.List_getUBLTaxWithHoldingTaxTaxCatalog_Number_java.util.Date_Number",[idUBLInvoice,issueDate, state]);
    }

    public async getTaxHoldValueListByIDUBLTaxWithHoldingTax(idUBLTaxWithHoldingTax: number, issueDate: any):Promise<any> {
        return this.getCustomService("QuickDataERPCore","java.util.List_getTaxHoldValueListByIDUBLTaxWithHoldingTax_Number_java.util.Date",[idUBLTaxWithHoldingTax, issueDate]);
    }
   
      
}